// import LanguagePicker from "components/LanguagePicker";
import SearchBox from "./SearchBox";
import UserSection from "./UserSection";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import useUser from "context/hooks/user";
import { clarity } from "react-microsoft-clarity";
import { useEffect } from "react";
import { Cookies } from "react-cookie-consent";
const Header = () => {
  const { data: userDetail } = useUser();
  const { dir, tenant: tenantDetail } = useAppSelector(getSettings);

  useEffect(() => {
    if (Cookies.get("nexmeCookieConsent") === "true") {
      clarity.identify(userDetail?.email, {
        first_name: userDetail?.first_name,
        last_name: userDetail?.last_name,
        email: userDetail?.email,
        phone: userDetail?.phone,
        id: userDetail?._id,
      });
    }
  }, [userDetail]);
  return (
    <>
      <header
        className="sticky top-0 w-full z-[5] bg-white shadow shadow-theme-gray"
        dir={dir}
      >
        <div className="p-4  w-full flex items-center justify-between">
          <div className="flex items-center gap-4 md:gap-6">
            {/* <Link to="/">
              <img
                src={require("assets/logo/nexme-logo.png")}
                className="w-[25vw] md:w-44 h-20 object-contain"
                title="Nexme"
                alt="Nexme"
              />
            </Link> */}
            {tenantDetail?.profile_image ? (
              <a href={tenantDetail?.website} target="_blank" rel="noreferrer">
                <img
                  src={tenantDetail?.profile_image}
                  className="w-[25vw] md:w-44 h-20 object-contain"
                  title={tenantDetail?.institution_title}
                  alt={tenantDetail?.institution_title || ""}
                />
              </a>
            ) : (
              ""
            )}
            <div className="hidden md:block">
              <SearchBox />
            </div>
          </div>
          <div className="flex items-center gap-4 md:gap-6">
            {/* <LanguagePicker /> */}
            <UserSection />
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
